import { useLocation } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";
import "./style.css";
import { useContext } from "react";
import { DasboardContext } from "../../context/dashboard-context";

const Breadcrumb = ({ showPath, id }) => {
  const location = useLocation();
  const path = location.pathname;

  const { sidebarOpen, setSidebarOpen, userInfo } = useContext(DasboardContext);

  const pathMap = {
    "/": "Ana Sayfa",
    "/homepage": "Ana Sayfa",
    "/devices": "Cihazlar",
    "/device-list": "Cihaz Listesi",
    "/alarms": "Alarm Listesi",
    "/user-list": "Kullanıcılar",
    "/organisation": "Organizasyon",
    "/login-detail": "Ayarlar",
    "/activities": "Aktiviteler",
  };

  // Dinamik route'lar (id içerenler) için prefix bazlı eşleştirme.
  // En spesifikten en genele doğru sıralanmalı (Viva02P/activities önce).
  const prefixMap = [
    { prefix: "/viva02p/activities/", label: "Aktiviteler" },
    { prefix: "/viva02p/", label: "Cihaz Detay" },
    { prefix: "/viva03d/", label: "Cihaz Detay" },
    { prefix: "/v46-vitals/", label: "Vital Logları" },
    { prefix: "/nursing-home-detail/", label: "Kurum Detay" },
  ];

  let currentPathName = pathMap[path];
  if (!currentPathName) {
    const match = prefixMap.find((p) => path.startsWith(p.prefix));
    currentPathName = match ? match.label : path.substring(1).toUpperCase();
  }

  return (
    <div className={`breadcrumb-wrapper ${sidebarOpen ? "" : "close"}`}>
      <div>
        <AiOutlineMenu onClick={() => setSidebarOpen(!sidebarOpen)} />
        {showPath !== "show" && <p>{currentPathName}</p>}
        {id && <p>{id.suiteName}</p>}
      </div>
      <div>
        <p>Hoşgeldiniz, {userInfo?.username}.</p>
      </div>
    </div>
  );
};

export default Breadcrumb;
